import { createContext, useState } from "react";
import { DummyKeaApi, IKeaApi, useKeaApi } from "./IKeaApi";
import { Schema, SchemaWithPermission } from "../../types/Schema";
import { ByteFile } from "../../types/ByteFile";
import { KeyValueEntry } from "../../types/KeyValueEntry";
import { TextFile } from "../../types/TextFile";
import { SchemaTree, SchemaTreeWithPermission } from "../../types/SchemaTree";
import { GradingService } from "../../types/GradingService";

type ApiContextType = {
  byteFileApi: IKeaApi<ByteFile, ByteFile>;
  keyValueApi: IKeaApi<KeyValueEntry, KeyValueEntry>;
  schemaApi: IKeaApi<Schema, SchemaWithPermission>;
  gradingServiceApi: IKeaApi<GradingService, GradingService>;
  schemaTreeApi: IKeaApi<SchemaTree, SchemaTreeWithPermission>;
  textFileApi: IKeaApi<TextFile, TextFile>;
};

const defaultApiContext: ApiContextType = {
  byteFileApi: DummyKeaApi<ByteFile, ByteFile>("/authorui/bytefiles"),
  keyValueApi: DummyKeaApi<KeyValueEntry, KeyValueEntry>("/authorui/keyvalues"),
  schemaApi: DummyKeaApi<Schema, SchemaWithPermission>("/authorui/schemas"),
  gradingServiceApi: DummyKeaApi<GradingService, GradingService>("authorui/gradingservices"),
  schemaTreeApi: DummyKeaApi<SchemaTree, SchemaTreeWithPermission>("/authorui/schematrees"),
  textFileApi: DummyKeaApi<TextFile, TextFile>("/authorui/textfiles"),
};

// Create the context
export const ApiContext = createContext<ApiContextType>(defaultApiContext);

// @ts-ignore
export const KeaApiProvider = ({ children }) => {
  const apiContext: ApiContextType = {
    byteFileApi: useKeaApi<ByteFile, ByteFile>("/authorui/bytefiles", [], ...useState<ByteFile[]>([])),
    keyValueApi: useKeaApi<KeyValueEntry, KeyValueEntry>("/authorui/keyvalues", [], ...useState<KeyValueEntry[]>([])),
    schemaApi: useKeaApi<Schema, SchemaWithPermission>(
      "/authorui/schemas",
      ["writable"],
      ...useState<SchemaWithPermission[]>([]),
    ),
    gradingServiceApi: useKeaApi<GradingService, GradingService>(
      "/authorui/gradingservices",
      [],
      ...useState<GradingService[]>([]),
    ),
    schemaTreeApi: useKeaApi<SchemaTree, SchemaTreeWithPermission>(
      "/authorui/schematrees",
      ["writable"],
      ...useState<SchemaTreeWithPermission[]>([]),
    ),
    textFileApi: useKeaApi<TextFile, TextFile>("/authorui/textfiles", [], ...useState<TextFile[]>([])),
  };

  return <ApiContext.Provider value={apiContext}>{children}</ApiContext.Provider>;
};
